import { render, staticRenderFns } from "./BoxCards.vue?vue&type=template&id=2366d6c4&scoped=true"
import script from "./BoxCards.vue?vue&type=script&lang=js"
export * from "./BoxCards.vue?vue&type=script&lang=js"
import style0 from "./BoxCards.vue?vue&type=style&index=0&id=2366d6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2366d6c4",
  null
  
)

export default component.exports